import { ServerOperatingSystems } from "@carbon/pictograms-react";
import { Button, Column, FlexGrid, Stack } from "@carbon/react";
import React from "react";

import { useT } from "src/internationalization";

type PageErrorProps = {
  title?: string | null;
  onClick?: () => void;
  description?: string | React.ReactElement | null;
  textButton?: string;
};
const PageError: React.FC<PageErrorProps> = ({ title, onClick, description, textButton }) => {
  const t = useT();

  return (
    <FlexGrid fullWidth className="flex full-height">
      <Column className="flex flex-col m-auto">
        <Stack gap={7}>
          <ServerOperatingSystems aria-label="error" />
          <div>
            <h2>{title ?? t("component.error.page.title")}</h2>
            <p>{description ?? t("component.error.page.description")}</p>
          </div>
          <Button
            onClick={() => {
              if (onClick) onClick();
              else {
                window.location.reload();
              }
            }}
          >
            {textButton ?? t("component.error.page.button")}
          </Button>
        </Stack>
      </Column>
    </FlexGrid>
  );
};

export default PageError;
